export default "__VITE_ASSET__BOGjXF8C__"